<script lang="ts">
  import Avatar from '$shared/Avatar.svelte';

  /** Read-only preview of a user's saved tracks. */
  interface SavedItem {
    id: number;
    title: string | null;
    artist: string | null;
    style: string | null;
    submitter: string | null;
    avatar_url: string | null;
    duel_id: number | null;
    duel_name: string | null;
    type: string;
    youtube_id: string | null;
    soundcloud_url: string | null;
    tiktok_url: string | null;
    yt_view_count: number | null;
    lb_listen_count: number | null;
    favorited_at: string;
  }

  let { items, isOwn = false }: { items: SavedItem[]; isOwn?: boolean } = $props();

  function detailHref(it: SavedItem): string {
    return `#/tracks/${it.id}`;
  }
</script>

{#if items.length > 0}
  <section class="saved">
    <div class="saved-head">
      <h2>Saved Tracks</h2>
      {#if isOwn}
        <a class="view-all" href="#/account/saved">View all ›</a>
      {/if}
    </div>
    <div class="saved-list">
      {#each items as it (it.id)}
        <a class="saved-row" href={detailHref(it)}>
          <div class="saved-info">
            <span class="saved-title">{it.title || 'Untitled'}</span>
            <span class="saved-meta">
              {#if it.submitter}
                <Avatar username={it.submitter} avatarUrl={it.avatar_url} size="xs" />
                {it.submitter}
              {:else if it.artist}
                {it.artist}
              {/if}
            </span>
          </div>
        </a>
      {/each}
    </div>
  </section>
{/if}

<style>
  .saved {
    margin-top: 1.5rem;
  }
  .saved-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 0.75rem;
  }
  h2 {
    font-size: 1.1rem;
    margin: 0;
  }
  .view-all {
    font-size: 0.8rem;
    color: var(--cyan);
    text-decoration: none;
  }
  .saved-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .saved-row {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.6rem 0.8rem;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    text-decoration: none;
    color: var(--text);
  }
  .saved-row:hover {
    border-color: var(--cyan);
  }
  .saved-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
  }
  .saved-title {
    font-weight: 600;
    font-size: 0.9rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .saved-meta {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.78rem;
    color: var(--text-muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
